<script>
export default {
  name: "new-pencil-icon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.84006 2.4L3.36673 8.19334C3.16006 8.41334 2.96006 8.84667 2.92006 9.14667L2.6734 11.3067C2.58673 12.0867 3.14673 12.62 3.92006 12.4867L6.06673 12.12C6.36673 12.0667 6.78673 11.8467 6.9934 11.62L12.4667 5.82667C13.4134 4.82667 13.8401 3.68667 12.3667 2.29334C10.9001 0.913335 9.78673 1.4 8.84006 2.4Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.92676 3.36667C8.21342 5.20667 9.70676 6.61334 11.5601 6.8"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 14.6667H14"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
